var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-wrapper"},[_c('input',{class:[
      'checkbox',
      { 'prevent-overflow': _vm.preventOverflow },
      { 'radio-style': _vm.radioStyle }
    ],attrs:{"id":_vm.id,"name":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){$event.preventDefault();return _vm.handleInput.apply(null, arguments)}}}),_c('label',{style:(_vm.labelStyle),attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }